import { css } from 'linaria';

export const adplatformTrainingWebinarSectionTitle = css`
  && {
    margin-bottom: 24px;

    @media (--to-desktop) {
      font-size: 22px;
      line-height: 28px;
    }
  }
`;
